import NotFound from "../components/NotFound";

const PageNotFound = () => {
  return (
    <NotFound></NotFound>
  )
}
export default PageNotFound;